/**
 * <mj-ring-enhancer> -- plays the slide behind sections/mj-ring-enhancer.liquid.
 *
 * The move itself is a CSS transition; all this does is decide when to start it, which
 * is the one thing CSS cannot answer. The enhancer is parked off the right edge in the
 * stylesheet, so if this file never runs the section still reads correctly -- it just
 * shows the plain ring, which is the desktop comp exactly.
 *
 * It plays once. Replaying on every scroll past would turn a demonstration into a
 * fidget, and the finished state is the one the copy is selling.
 */

class MjRingEnhancer extends HTMLElement {
  connectedCallback() {
    const media = this.querySelector('[data-mj-enh-media]');
    const slide = this.querySelector('[data-mj-enh-slide]');
    if (!media || !slide) return;

    // Reduced motion is handled in CSS, which puts the enhancer straight on the ring.
    // Observing anyway would add a class that changes nothing; skip the work.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.classList.add('is-revealed');
          this.observer.disconnect();
        }
      },
      /*
       * Wait for a little over half the ring to be on screen. Firing at the first pixel
       * would play the slide below the fold on a fast scroll and leave nothing to see by
       * the time the section arrives.
       */
      { threshold: 0.55 }
    );

    this.observer.observe(media);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('mj-ring-enhancer')) {
  customElements.define('mj-ring-enhancer', MjRingEnhancer);
}
